import { render, staticRenderFns } from "./CoverDetailsInfo.vue?vue&type=template&id=69fbd833"
import script from "./CoverDetailsInfo.vue?vue&type=script&lang=js"
export * from "./CoverDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./CoverDetailsInfo.vue?vue&type=style&index=0&id=69fbd833&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports